export default __webpack_public_path__ + "static/media/7707ROUGE.326693c4.pdf";